(() => {
  'use strict';
  if (customElements.get('bellomo-coordinate-offer')) return;

  class BellomoCoordinateOffer extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('click', event => {
        if (event.target.closest('[data-offer-dismiss]')) this.finish();
      }, options);
      this.addEventListener('bellomo:coordinate-added', () => this.finish(), options);
      this.addEventListener('keydown', event => this.trap(event), options);
    }

    disconnectedCallback() {
      this.events?.abort();
      document.body.classList.remove('bellomo-offer-open');
    }

    show(dialog, card, component, opener) {
      this.replaceChildren(dialog);
      this.dialog = dialog;
      this.opener = opener;
      const content = document.createElement('bellomo-cart-coordinates');
      content.className = 'bellomo-coordinates';
      Object.assign(content.dataset, component.dataset);
      content.dataset.addLabel = dialog.dataset.addLabel;
      content.setAttribute('aria-labelledby', 'bellomo-offer-title');
      const list = document.createElement('ul');
      list.className = 'bellomo-coordinates__list ls-none p-zero m-zero';
      list.append(card);
      content.append(list);
      card.querySelector('[data-coordinate-add]').classList.replace('btn-secondary', 'btn-primary');
      const image = card.querySelector('img');
      if (image) { image.loading = 'eager'; image.sizes = '88px'; }
      dialog.querySelector('[data-offer-content]').append(content);
      dialog.addEventListener('cancel', event => {
        event.preventDefault();
        event.stopPropagation();
        this.finish();
      }, { signal: this.events.signal });
      dialog.showModal();
      document.body.classList.add('bellomo-offer-open');
      card.querySelector('[data-coordinate-add]').focus({ preventScroll: true });
    }

    trap(event) {
      if (event.key === 'Escape' && this.dialog?.open) {
        event.preventDefault();
        event.stopPropagation();
        document.addEventListener('keyup', keyup => {
          if (keyup.key === 'Escape') keyup.stopImmediatePropagation();
        }, { capture: true, once: true });
        this.finish();
        return;
      }
      if (event.key !== 'Tab' || !this.dialog?.open) return;
      const controls = [...this.dialog.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href], [tabindex="0"]')];
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }

    finish() {
      if (!this.dialog?.open) return;
      this.dialog.close();
      document.body.classList.remove('bellomo-offer-open');
      const drawer = document.querySelector('sht-cart-drwr');
      const opener = this.opener?.isConnected ? this.opener : document.querySelector('#headerCartStatus');
      if (drawer?.openDrawer) {
        drawer.openDrawer(opener);
        requestAnimationFrame(() => drawer.querySelector('.js-cart-drawer-btn-close')?.focus({ preventScroll: true }));
      } else {
        opener?.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('bellomo-coordinate-offer', BellomoCoordinateOffer);

  function offerAfterConfirmedAddition(event) {
    const native=event.type==='bellomo:product-added'&&event.target instanceof HTMLElement&&event.target.matches('sht-prd-frm');
    const chat=event.type==='bellomo:chat-product-added'&&event.target===document;
    if (!native&&!chat) return;
    if (document.querySelector('bellomo-coordinate-offer dialog[open]')) return;
    const result = event.detail?.result;
    const id = String(result?.variant_id || result?.id || '');
    if (!/^\d+$/.test(id) || typeof result?.sections?.['cart-drawer'] !== 'string') return;
    if (!customElements.get('bellomo-cart-coordinates') || !HTMLDialogElement.prototype.showModal) return;
    const parsed = new DOMParser().parseFromString(result.sections['cart-drawer'], 'text/html');
    const source = parsed.querySelector(`template[data-coordinate-source="${id}"]`);
    const card = source?.content.querySelector('[data-coordinate-item]')?.cloneNode(true);
    const component = parsed.querySelector('bellomo-cart-coordinates');
    const shell = parsed.querySelector('template[data-coordinate-offer-shell]');
    const drawer = document.querySelector('sht-cart-drwr');
    const badge = document.querySelector('#headerCartStatus');
    const header = typeof result.sections['header-cart-status'] === 'string'
      ? new DOMParser().parseFromString(result.sections['header-cart-status'], 'text/html').querySelector('.shopify-section') : null;
    if (!card || !component || !shell || !drawer?.openDrawer || !header || !badge) return;
    if (card.dataset.variantId === id) return;
    let offer = document.querySelector('bellomo-coordinate-offer');
    if (!offer) { offer = document.createElement('bellomo-coordinate-offer'); document.body.append(offer); }
    try {
      const notification = document.querySelector('sht-cart-noti');
      if (notification && !notification.hidden) notification.close();
      if (drawer.hasAttribute('open')) drawer.closeDrawer();
      offer.show(shell.content.querySelector('dialog').cloneNode(true), card, component, event.detail.opener);
      badge.innerHTML = header.innerHTML;
      event.preventDefault();
    } catch {
      offer.dialog?.close();
      document.body.classList.remove('bellomo-offer-open');
    }
  }
  document.addEventListener('bellomo:product-added',offerAfterConfirmedAddition);
  document.addEventListener('bellomo:chat-product-added',offerAfterConfirmedAddition);
})();
